// The Polygon line: verify an inclusion proof in the platform's stored format
// (merkle_tree.py): sorted-pair hashing with the proof's hash_algorithm.
import { sha256 } from "@noble/hashes/sha256";
import { concat, fromHex, toHex } from "./encoding";

export function computeRoot(leaf: string, proof: string[], alg = "sha256"): string {
  if (alg !== "sha256") throw new Error(`unsupported Merkle hash algorithm ${alg}`);
  let cur = fromHex(leaf);
  for (const s of proof) {
    const sib = fromHex(s);
    cur = toHex(cur) <= toHex(sib) ? sha256(concat(cur, sib)) : sha256(concat(sib, cur));
  }
  return "0x" + toHex(cur);
}

export function verifyInclusion(p: { leaf: string; proof?: string[]; root?: string; hash_algorithm: string }): boolean {
  if (!p.root) return false;
  return computeRoot(p.leaf, p.proof ?? [], p.hash_algorithm).toLowerCase() === p.root.toLowerCase();
}
